import { z } from 'zod';

import { idSchema, isoDateSchema, jsonMetaSchema } from './common.schema';

export const channelTypeSchema = z.enum([
  'telegram',
  'whatsapp',
  'vk',
  'email',
  'chat',
  'wildberries',
  'ozon',
  'avito',
  'sms',
  /** Канал магазина через платформу продаж (пересылка, без своих ключей) */
  'partner',
  'instagram',
  'facebook',
  'custom',
]);
export type ChannelType = z.infer<typeof channelTypeSchema>;

export const channelSchema = z.object({
  id: idSchema,
  workspace_id: idSchema,
  type: channelTypeSchema,
  name: z.string().min(1).max(200),
  external_identifier: z.string().nullable().optional(),
  is_active: z.boolean(),
  last_health_check: jsonMetaSchema.optional(),
  config: jsonMetaSchema.default({}),
  created_at: isoDateSchema,
  updated_at: isoDateSchema,
});
export type Channel = z.infer<typeof channelSchema>;

/** Credentials schema — варьируется per type. Здесь — ducktype, конкретные коннекторы валидируют сами. */
export const channelCredentialsSchema = z.record(z.unknown());

/** Предварительная проверка credentials до создания канала (кнопка «Проверить подключение»). */
export const testChannelCredentialsSchema = z.object({
  type: channelTypeSchema,
  credentials: channelCredentialsSchema,
});

export const createChannelSchema = z.object({
  type: channelTypeSchema,
  name: z.string().min(1).max(200),
  credentials: channelCredentialsSchema,
  config: jsonMetaSchema.optional(),
  external_identifier: z.string().optional(),
  /** Магазин канала; пусто — общий для всех магазинов аккаунта */
  store_id: idSchema.nullable().optional(),
});

export const updateChannelSchema = z
  .object({
    name: z.string().min(1).max(200),
    credentials: channelCredentialsSchema,
    config: jsonMetaSchema,
    external_identifier: z.string(),
    is_active: z.boolean(),
    store_id: idSchema.nullable(),
  })
  .partial();
